export enum CompanyEnum {
    FBP = 'Fabulous Beyond Productions',
    TUCKED = 'Tucked',
    TROPIX = 'Tropix',
    PARTY_WITH_GINGER = 'Party With Ginger',
    LONDON_COCKTAIL_CLUB = 'London Cocktail Club',
    BOAT_SHOW_COMEDY = 'Boat Show Comedy'
}
